import React from "react";

import { Container } from "./styles";

const Icon = ({ children, ...props }) => (
  <Container {...props}>{children}</Container>
);

export default Icon;
